import { ElementOverrides, Template } from '@/models/drawing/drawingTypes.ts'
import DrawingCanvas from './DrawingCanvas.tsx'

interface DrawingTemplateRendererProps {
  template: Template
  className?: string
  zoom?: number
  elementOverrides?: ElementOverrides
}

export default function DrawingTemplateRenderer({
  template,
  className = '',
  zoom = 1,
  elementOverrides,
}: DrawingTemplateRendererProps) {
  return (
    <div className={`w-full h-full ${className}`}>
      <DrawingCanvas
        template={template}
        zoom={zoom}
        elementOverrides={elementOverrides}
      />
    </div>
  )
}
